<template>
  <div class="chat-header">
    <div class="solomon-profile">
      <i class="icon icon--becle-profile"></i>
      <div :class="['status', { disabled: !isConnected }]"></div>
    </div>
    <div class="solomon-detail">
      <div class="solomon-name">UX GPT<i class="icon icon--beta"></i></div>
      <div class="gpt-version">{{ $t('mine.chat.intro') }}</div>
    </div>
    <div class="button-container">
      <span v-if="questionCount.exceeded" class="question-alert">
        <i class="icon icon--info-red"></i>
        <div class="question-alert-tooltip">
          {{ $t('mine.chat.questionLimitAlert') }}
        </div>
      </span>
      <div class="question-count">
        <span class="count-title">{{ $t('mine.chat.questionLimit') }}</span>
        <span :class="['count-value', { 'init': !questionCount.count }, { 'over-limit': questionCount.exceeded }]">
          {{ questionCount.total - questionCount.count }} / {{ questionCount.total }}
        </span>
      </div>
      <button @click="$emit('expand')">
        <i class="icon size-24" :class="fullScreenMode ? 'icon--arrow-reduce' : 'icon--arrow-expand'"></i>
      </button>
      <button @click="$emit('close')">
        <i class="icon icon--close-size24"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChatHeader',
  props: {
    isConnected: Boolean,
    gptVersion: String,
    fullScreenMode: Boolean,
    questionCount: {
      type: Object,
      default: () => ({ total: 0, count: 0, exceeded: false })
    }
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.chat-header {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
}

.solomon-profile {
  position: relative;
  width: 42px;
  height: 42px;
  .solomon-profile-img {
    width: 100%;
    height: 100%;
    border-radius: 100%;
    box-shadow: 0px 0px 0px 0.36px #22637829 inset;
  }
  .status {
    position: absolute;
    right: 1px;
    bottom: 2px;
    width: 10px;
    height: 10px;
    border-radius: 100%;
    border: 2px solid #FFF;
    background-color: #58C900;
    box-sizing: border-box;
    box-shadow: 0px 1px 2px 0px #00000040;
    &.disabled {
      background-color: #e92020;
    }
  }
}

.solomon-detail {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding-left: 16px;
  .solomon-name {
    position: relative;
    width: fit-content;
    color: #111;
    font-size: 13px;
    font-weight: 600;
    .icon--beta {
      position: absolute;
      top: -1px;
      right: -4px;
      transform: translateX(100%);
    }
  }
  .gpt-version {
    color: #7D7D7D;
    font-size: 12px;
    font-weight: 500;
  }
}

.button-container {
  @include flexYcenter;
  position: absolute;
  top: 0;
  right: 0;
  gap: 16px;

  .question-alert {
    position: relative;
    display: flex;
    margin-right: -8px;
    &-tooltip {
      position: absolute;
      top: -11px;
      left: 50%;
      transform: translate(-50%, -100%);
      padding: 9px 10px;
      border-radius: 6px;
      background-color: #fff;
      color: #E60724;
      font-size: 12px;
      font-weight: 400;
      white-space: nowrap;
      box-shadow:
        0 8px 15px 0 rgba(0, 0, 0, 0.16),
        0 0 0 1px rgba(0, 0, 0, 0.16);
      &::after {
        content: '';
        position: absolute;
        width: 4px;
        height: 4px;
        bottom: 0;
        transform: translate(-50%, 50%) rotate(-45deg);
        left: 50%;
        box-shadow: -1px 1px 0 0 rgba(0, 0, 0, 0.16);
        background-color: #fff;
      }
    }
  }
  .question-count {
    @include flexYcenter;
    padding: 8px 10px;
    gap: 8px;
    margin-right: 2px;
    border-radius: 25px;
    border: 1px solid #D9D9D9;
    background: #FFF;
    .count-title {
      color: #7D7D7D;
      font-size: 12px;
    }
    .count-value {
      color: #444;
      font-size: 14px;
      font-weight: 600;
      &.init {
        color: #7D7D7D;
      }
      &.over-limit {
        color: #E60724;
      }
    }
  }
}
</style>
